import React from 'react';
import { Link } from 'react-router-dom';

const AllocationBlock = props => {
    const style_lg= {
        backgroundImage: `url(/images/${props.data.img})`
    }
    const style_sm= {
        backgroundImage: `url(/images/${props.data.sm})`
    }

     
    const block = props.index % 2 === 0 ? ' right' : ' left' ;
    const col = props.index === 0 ? ' col-sm-12 first ' : ' col-sm-6 ';
    const imgCol =  props.index === 0 ? ' col-3 img-item ' : ' col-5 img-item ';
    //const status =props.data.status;
    return (
        <div className={"allocation-block" +col + block } >
            <div className="row ">
                <div className={imgCol}>
                    
                    {props.status &&  <div className="active_Rubrique" ></div>} 
                    <div className="img-block __lg" style={style_lg} ></div>
                    <div className="img-block __sm" style={style_sm} ></div>
                </div>
                <div className="col text-item">
                    <h5> 
                    { 
                        props.index != 0 &&
                        <span className="index">{props.index + '. '}</span>
                    }
                    {props.data.title}
                    </h5>
                   
                    
                    <p> {props.data.text} </p>
                    {/* <p className="item">
                        <span>&#10004;</span> Avis de décès
                    </p> */}
                    <div className="button-container">
                        <Link to={'/' + props.data.link} onClick={() => { if (!props.status) props.pushToDataLayer(props.data.gtmEventAcces); else props.pushToDataLayer(props.data.gtmEventUpdate);}}>
                        	{!props.status &&  <button type="button" className="btn btn-primary"><span>&#10140;</span>Acceder</button>}
                        	{props.status &&  <button type="button" className="btn btn-primary"><span>&#10140;</span>Modifier</button>}                        	
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllocationBlock;


// WEBPACK FOOTER //
// ./src/components/DashboardPage/AllocationBlock.js